export const LEVELS = {
  'ALL': 0,
  'DEBUG': 1,
  'LOG': 2,
  'INFO': 3,
  'WARN': 4,
  'ERROR': 5,
  'OFF': 9
}



// WEBPACK FOOTER //
// ./src/core/enum.js